// src/app/store.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/authSlice.js";
import categorieReducer from "../features/categorySlice.js";
import matchReducer from "../features/matchSlice.js";
import yearReducer from "../features/yearSlice.js";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    categorie: categorieReducer,
    match: matchReducer,
    year: yearReducer,
  },
});
